import { render, staticRenderFns } from "./Lgx177554228301004800.vue?vue&type=template&id=72238ac2&"
import script from "./Lgx177554228301004800.vue?vue&type=script&lang=js&"
export * from "./Lgx177554228301004800.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports